import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CheckIconWrapper, CheckboxContainer, CheckboxWrapper } from './Checkbox.style';

export interface CheckboxPropsType {
    className?: string;
    children: JSX.Element | string;
    labelSide?: 'left' | 'right';
    isChecked: boolean;
    isBackground?: boolean;
    isDisabled: boolean;
    onChange: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
    dataTest?: string;
}

export const Checkbox = observer(
    'Checkbox',
    ({
        className,
        children,
        labelSide,
        onChange,
        isChecked,
        isBackground,
        isDisabled,
        dataTest,
    }: CheckboxPropsType): JSX.Element => {
        const checkboxRef = React.useRef<HTMLSpanElement>(null);

        const handleKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>): void => {
            if (isDisabled) return;

            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                if (checkboxRef.current !== null) {
                    checkboxRef.current.click();
                }
            }
        };

        return (
            <CheckboxContainer isDisabled={isDisabled}>
                {labelSide === 'left' ? children : null}

                <CheckboxWrapper
                    ref={checkboxRef}
                    className={className}
                    onClick={onChange}
                    onKeyDown={handleKeyDown}
                    tabIndex={isDisabled ? -1 : 0}
                    role='checkbox'
                    aria-checked={isChecked}
                    aria-disabled={isDisabled}
                    isChecked={isChecked}
                    isBackground={isBackground}
                    isDisabled={isDisabled}
                    data-test={dataTest}
                >
                    {isChecked ? <CheckIconWrapper isChecked={isChecked} /> : null}
                </CheckboxWrapper>
                {labelSide === 'right' ? children : null}
            </CheckboxContainer>
        );
    }
);
